import Diamond from '../src/Diamond';
export default Diamond;
